import { AnchorButton, Button, H1, Text } from '@payaca/ambrosia';
import { FC } from 'react';
import { Link } from 'react-router-dom';

import { DocumentBlueprintsTable } from '@/ui/components/documentBlueprints/DocumentBlueprintsTable';
import { useChatAgent } from '@/ui/components/chatAgent/ChatAgentContextProvider';

export const CreateTemplateBlueprintPicker: FC = () => {
  const { showChatAgent, inputRef } = useChatAgent();

  const focusChatInput = () => {
    showChatAgent();
    // Give the panel a frame to mount/open before moving focus into it.
    requestAnimationFrame(() => inputRef.current?.focus());
  };

  return (
    <div className="bg-gray-50 size-full overflow-y-auto">
      <div className="p-4 flex flex-col gap-4">
        <div>
          <H1>Create a document template</H1>
          <div className="mt-2">
            <Text colour="muted">
              Customise a template from our ready-made library below,{' '}
              <Button variant="link" onClick={focusChatInput}>
                describe your document to Agent Dave
              </Button>
              , or{' '}
              <AnchorButton
                as={Link}
                to="/templates/document-templates/new/manual"
                variant="link"
              >
                upload the HTML code yourself
              </AnchorButton>
            </Text>
          </div>
        </div>

        <DocumentBlueprintsTable />
      </div>
    </div>
  );
};
